import { Component, OnInit } from '@angular/core'

import { EventsService } from '../../services/events.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'

import { Event } from '../../models/event.model'

import * as moment from 'moment'
import debounce from 'lodash.debounce'
import { config } from '../../config/config'

@Component({
  selector: 'ld-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.css')]
})
export class HomeComponent implements OnInit {
  private events: Event[] = []
  private searchQuery: string = ''
  private searchResults: Event[] = []
  private showSearchResults: boolean = false
  private debouncedSearchEvents: () => Promise<void>

  constructor (
    private messagesDelegate: MessagesDelegate,
    private eventsService: EventsService) {
    this.debouncedSearchEvents = debounce(this.searchEvents, config.debounceTime)
  }

  async ngOnInit () {
    const now = moment()
    this.events = await this.eventsService.find({
      from: now.format('YYYYMMDD'),
      to: now.add(config.upcomingDays, 'days').format('YYYYMMDD')
    })
      .catch(() => {
        this.messagesDelegate.add('APP.EVENTSLIST.ERROR')
        return []
      })
  }

  async searchEvents () {
    if (this.searchQuery) {
      this.searchResults = await this.eventsService.find({
        search: this.searchQuery
      })
      .catch(() => {
        this.messagesDelegate.add('APP.EVENTSLIST.ERROR')
        return []
      })
      this.showSearchResults = true
    } else {
      this.searchResults = []
      this.showSearchResults = false
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/home/home.component.ts